// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__31nhR","header":"MessagesList_header__mXhvS","chat":"MessagesList_chat__R-bDf"};